// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2-XE5","right":"styles_right__3j04E"};